export const RestaurantTypes = {
  FullServiceRestaurant: 'full_service_restaurant',
  FastCasual: 'fast_casual',
  QuickServiceTakeaway: 'quick_service_takeaway',
  CafeAndBakery: 'cafe_and_bakery',
  DessertAndIceCream: 'dessert_and_ice_cream',
  DrinksAndBar: 'drinks_and_bar',
  DeliveryOnlyOrGhostKitchen: 'delivery_only_or_ghost_kitchen',
};

export const CuisineTypes = {
  // Top/General
  Pizza: 'pizza',
  Burgers: 'burgers',
  ChickenFried: 'chicken_fried',
  Wings: 'wings',
  KebabDoner: 'kebab_doner',
  Sandwiches: 'sandwiches',
  Wraps: 'wraps',
  Salads: 'salads',
  Healthy: 'healthy',
  Bowls: 'bowls',
  Vegan: 'vegan',
  Vegetarian: 'vegetarian',
  GlutenFree: 'gluten_free',
  Halal: 'halal',

  // Asian & Pacific
  Sushi: 'sushi',
  Japanese: 'japanese',
  Ramen: 'ramen',
  UdonSoba: 'udon_soba',
  Korean: 'korean',
  KoreanFriedChicken: 'korean_fried_chicken',
  Chinese: 'chinese',
  Sichuan: 'sichuan',
  CantoneseDimSum: 'cantonese_dim_sum',
  Thai: 'thai',
  Vietnamese: 'vietnamese',
  Malaysian: 'malaysian',
  Indonesian: 'indonesian',
  Filipino: 'filipino',
  Poke: 'poke',
  HotPot: 'hot_pot',
  DumplingsGyozaBao: 'dumplings_gyoza_bao',

  // South Asian
  Indian: 'indian',
  Biryani: 'biryani',
  Pakistani: 'pakistani',
  SriLankan: 'sri_lankan',
  Nepalese: 'nepalese',

  // Middle East & Mediterranean
  Turkish: 'turkish',
  Lebanese: 'lebanese',
  Syrian: 'syrian',
  Israeli: 'israeli',
  Egyptian: 'egyptian',
  PersianIranian: 'persian_iranian',
  Iraqi: 'iraqi',
  Afghan: 'afghan',
  ShawarmaFalafel: 'shawarma_falafel',
  MezzeGrill: 'mezze_grill',
  Greek: 'greek',
  Mediterranean: 'mediterranean',

  // Europe
  Italian: 'italian',
  Pasta: 'pasta',
  French: 'french',
  SpanishTapas: 'spanish_tapas',
  Portuguese: 'portuguese',
  German: 'german',
  Austrian: 'austrian',
  Balkan: 'balkan',
  Hungarian: 'hungarian',
  Polish: 'polish',
  Czech: 'czech',
  Georgian: 'georgian',

  // Americas
  Mexican: 'mexican',
  TexMex: 'tex_mex',
  Peruvian: 'peruvian',
  Brazilian: 'brazilian',
  Argentinian: 'argentinian',
  Caribbean: 'caribbean',
  BBQAmerican: 'bbq_american',
  Steakhouse: 'steakhouse',
  AmericanGeneral: 'new_american',
  HotDogs: 'hot_dogs',

  // Seafood & Specialty
  Seafood: 'seafood',
  FishAndChips: 'fish_and_chips',
  SteamedFish: 'steamed_fish',

  // Breakfast, Bakery & Sweets
  BreakfastBrunch: 'breakfast_brunch',
  Bagels: 'bagels',
  Bakery: 'bakery',
  PastryDessert: 'pastry_dessert',
  WafflesCrepes: 'waffles_crepes',
  IceCreamGelato: 'ice_cream_gelato',
  Donuts: 'donuts',
  Cakes: 'cakes',

  // Beverage-led
  CoffeeCafe: 'coffee_cafe',
  BubbleTea: 'bubble_tea',
  JuiceSmoothies: 'juice_smoothies',
  Milkshakes: 'milkshakes',
  BarPub: 'bar_pub',
  WineBar: 'wine_bar',
  Cocktails: 'cocktails',

  // Other Concepts
  TapasMezeSmallPlates: 'tapas_meze_small_plates',
  Noodles: 'noodles',
  Soup: 'soup',
  Schnitzel: 'schnitzel',
  SoulFood: 'soul_food',
  ComfortFood: 'comfort_food',
  StreetFood: 'street_food',
  OrganicBio: 'organic_bio',
  KidsMenu: 'kids_menu',
};

export const CuisineCategories = {
  TopGeneral: 'top_general',
  AsianPacific: 'asian_pacific',
  SouthAsian: 'south_asian',
  MiddleEastMediterranean: 'middle_east_mediterranean',
  Europe: 'europe',
  Americas: 'americas',
  SeafoodSpecialty: 'seafood_specialty',
  BreakfastBakerySweets: 'breakfast_bakery_sweets',
  BeverageLed: 'beverage_led',
  OtherConcepts: 'other_concepts',
};

export const CuisineData = {
  [CuisineCategories.TopGeneral]: [
    CuisineTypes.Pizza,
    CuisineTypes.Burgers,
    CuisineTypes.ChickenFried,
    CuisineTypes.Wings,
    CuisineTypes.KebabDoner,
    CuisineTypes.Sandwiches,
    CuisineTypes.Wraps,
    CuisineTypes.Salads,
    CuisineTypes.Healthy,
    CuisineTypes.Bowls,
    CuisineTypes.Vegan,
    CuisineTypes.Vegetarian,
    CuisineTypes.GlutenFree,
    CuisineTypes.Halal,
    CuisineTypes.CoffeeCafe,
    CuisineTypes.BubbleTea,
    CuisineTypes.JuiceSmoothies,
    CuisineTypes.Milkshakes,
    CuisineTypes.BarPub,
    CuisineTypes.WineBar,
    CuisineTypes.Cocktails,
    CuisineTypes.TapasMezeSmallPlates,
    CuisineTypes.Noodles,
    CuisineTypes.Soup,
    CuisineTypes.Schnitzel,
    CuisineTypes.SoulFood,
    CuisineTypes.ComfortFood,
    CuisineTypes.StreetFood,
    CuisineTypes.OrganicBio,
    CuisineTypes.KidsMenu,
  ],
  [CuisineCategories.AsianPacific]: [
    CuisineTypes.Sushi,
    CuisineTypes.Japanese,
    CuisineTypes.Ramen,
    CuisineTypes.UdonSoba,
    CuisineTypes.Korean,
    CuisineTypes.KoreanFriedChicken,
    CuisineTypes.Chinese,
    CuisineTypes.Sichuan,
    CuisineTypes.CantoneseDimSum,
    CuisineTypes.Thai,
    CuisineTypes.Vietnamese,
    CuisineTypes.Malaysian,
    CuisineTypes.Indonesian,
    CuisineTypes.Filipino,
    CuisineTypes.Poke,
    CuisineTypes.HotPot,
    CuisineTypes.DumplingsGyozaBao,
  ],
  [CuisineCategories.SouthAsian]: [
    CuisineTypes.Indian,
    CuisineTypes.Biryani,
    CuisineTypes.Pakistani,
    CuisineTypes.SriLankan,
    CuisineTypes.Nepalese,
  ],
  [CuisineCategories.MiddleEastMediterranean]: [
    CuisineTypes.Turkish,
    CuisineTypes.Lebanese,
    CuisineTypes.Syrian,
    CuisineTypes.Israeli,
    CuisineTypes.Egyptian,
    CuisineTypes.PersianIranian,
    CuisineTypes.Iraqi,
    CuisineTypes.Afghan,
    CuisineTypes.ShawarmaFalafel,
    CuisineTypes.MezzeGrill,
    CuisineTypes.Greek,
    CuisineTypes.Mediterranean,
  ],
  [CuisineCategories.Europe]: [
    CuisineTypes.Italian,
    CuisineTypes.Pasta,
    CuisineTypes.French,
    CuisineTypes.SpanishTapas,
    CuisineTypes.Portuguese,
    CuisineTypes.German,
    CuisineTypes.Austrian,
    CuisineTypes.Balkan,
    CuisineTypes.Hungarian,
    CuisineTypes.Polish,
    CuisineTypes.Czech,
    CuisineTypes.Georgian,
  ],
  [CuisineCategories.Americas]: [
    CuisineTypes.Mexican,
    CuisineTypes.TexMex,
    CuisineTypes.Peruvian,
    CuisineTypes.Brazilian,
    CuisineTypes.Argentinian,
    CuisineTypes.Caribbean,
    CuisineTypes.BBQAmerican,
    CuisineTypes.Steakhouse,
    CuisineTypes.AmericanGeneral,
    CuisineTypes.HotDogs,
  ],
  [CuisineCategories.SeafoodSpecialty]: [CuisineTypes.Seafood, CuisineTypes.FishAndChips, CuisineTypes.SteamedFish],
  [CuisineCategories.BreakfastBakerySweets]: [
    CuisineTypes.BreakfastBrunch,
    CuisineTypes.Bagels,
    CuisineTypes.Bakery,
    CuisineTypes.PastryDessert,
    CuisineTypes.WafflesCrepes,
    CuisineTypes.IceCreamGelato,
    CuisineTypes.Donuts,
    CuisineTypes.Cakes,
  ],
  [CuisineCategories.BeverageLed]: [
    CuisineTypes.CoffeeCafe,
    CuisineTypes.BubbleTea,
    CuisineTypes.JuiceSmoothies,
    CuisineTypes.Milkshakes,
    CuisineTypes.BarPub,
    CuisineTypes.WineBar,
    CuisineTypes.Cocktails,
  ],
  [CuisineCategories.OtherConcepts]: [
    CuisineTypes.TapasMezeSmallPlates,
    CuisineTypes.Noodles,
    CuisineTypes.Soup,
    CuisineTypes.Schnitzel,
    CuisineTypes.SoulFood,
    CuisineTypes.ComfortFood,
    CuisineTypes.StreetFood,
    CuisineTypes.OrganicBio,
    CuisineTypes.KidsMenu,
  ],
};
